import { useMutation, useQueryClient } from "@tanstack/react-query";

import { knowledgeApi } from "@/api/services";

import { FOLDER_KNOWLEDGE_FILES_QUERY_KEY } from "./useGetFolderKnowledgeFiles";

export const useDeleteFolderKnowledgeFile = (folderUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) =>
      knowledgeApi.deleteFolderFile({ folderUuid, uuid }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FOLDER_KNOWLEDGE_FILES_QUERY_KEY, folderUuid],
      });
    },
  });
};
